import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme';
import useFetchInterceptor from './hooks/useFetchInterceptor';
import AppRoutes from './routes/Routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './services/AuthContext';
import useIdleTimer from './hooks/useIdleTimer';
import IdleWarningDialog from './components/common/IdleWarningDialog';

function App() {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    console.log(userData,"userDatauserData")
    // Initialize fetch interceptor to handle 403 errors
    useFetchInterceptor();
    const { showWarning, resetTimerManually } = useIdleTimer();
    
    return (
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <AuthProvider>
                    <BrowserRouter>
                        <AppRoutes />
                        <ToastContainer
                            position="top-center"
                            autoClose={2000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="dark"
                        />
                        <IdleWarningDialog open={showWarning} onContinue={resetTimerManually} />
                    </BrowserRouter>
                </AuthProvider>
            </ThemeProvider>
    );
}

export default App;